module.exports = __webpack_public_path__ + "img/software_time-matters.739d0f46.jpg";